import { FormValidatorType } from '@components/form';

import { unhandledRequest } from 'api/request';

export type H3BulkEditField = H3BulkEditStringField | H3BulkEditChoicesField | H3BulkEditDateField;

export type H3BulkEditStringField = {
  type: 'string';
  name: string;
  label: string;
  value?: string;
  validators: FormValidatorType[];
};
export type H3BulkEditDateField = {
  type: 'date';
  name: string;
  label: string;
  value?: string;
  validators: FormValidatorType[];
};

export type H3BulkEditChoicesField = {
  type: 'choices' | 'autocomplete';
  name: string;
  label: string;
  choices: string[][];
  value?: string;
  validators: FormValidatorType[];
};

export async function h3coreEnabled() {
  const response = await unhandledRequest.get<{ enabled: boolean }>({
    url: '/integrations/h3core/bulk-enabled/',
  });
  return response.data;
}

export async function h3coreBulkEditGetData() {
  const response = await unhandledRequest.get<H3BulkEditField[]>({
    url: '/integrations/h3core/bulk-edit/',
  });
  return response.data;
}

export type H3BulkEditCreateData = {
  applicationIds: number[];
  fields: H3BulkEditField[];
};

export async function h3coreBulkEditCreateData(data: H3BulkEditCreateData) {
  const response = await unhandledRequest.post({
    url: '/integrations/h3core/bulk-edit/',
    data,
  });
  return response.data;
}

export type H3BulkCreateData = {
  applicationIds: number[];
};

export async function h3coreBulkCreate(data: H3BulkCreateData) {
  const response = await unhandledRequest.post({
    url: '/integrations/h3core/bulk-create/',
    data,
  });
  return response.data;
}
